import React from 'react';
import { Pill, type PillKind } from './status';

interface PortalStatusPillProps {
  label: string;
  tone?: PillKind;
  announce?: boolean;
}

/** Shared static-by-default status presentation for Portal records. */
export const PortalStatusPill = ({
  label,
  tone = 'neutral',
  announce = false
}: PortalStatusPillProps): JSX.Element => (
  <Pill kind={tone} role={announce ? 'status' : undefined}>
    {label}
  </Pill>
);

